import React from 'react'
import '../css/main_style.css';
import '../css/index.css';
import MenuBar from '../pages/LoginMenu'
import ReloanContent from '../pages/reloanContent'
import Toppart from '../pages/toppart'
import Footer from '../pages/Footer'

export default function Payday() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<ReloanContent />
			<Footer />	
		</div>	
	)
}
		

	